module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAPCAYAAADtc08vAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADDSURBVHgBpZK7DcIwFEXPc9IzAEGiRRRkA8QGbABMEjEBbBBWYANGAEFEm4KCkgHAxuYjISD/U7nwue+jJwmdmAZIQmAMZkYNBIlxAdTEuYqGNApwo/vU4EB7KqihcF1X7uBIEFkpMuidwYsrBTjZtm2r30Ye0hLMpXTApwz+5P0uFZAl9zin8rwDWf1qJu1zmufJ7pe4jWYU3mpU10cvsuRHADnsCZZ2Wa9L1eNv2ZF7Bx4MbNXQPjfqj1yIHS8s+nMHP+JdDFiQEtAAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/v2-ask.png
// module id = d3/M
// module chunks = 36